// Worksheet messages data - avoiding JSON import issues
export const worksheetMessages = {
  worksheets: [
    {
      label: "After Hours Access",
      filename: "Cortex.AfterHourAccess.tsx",
      description: "A description of the availability and policies regarding after hours storage unit access.",
      messages: [
        {
          messageNumber: 1,
          variable: "AccessAfterHour1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "AccessAfterHour2",
          optional: true,
          enableSwitchVar: "AccessAfterHour2Enabled"
        }
      ]
    },
    {
      label: "Gate Code",
      filename: "Cortex.GateCode.tsx",
      description: "A description of relevant gate code policies.",
      messages: [
        {
          messageNumber: 1,
          variable: "AccessGateCode1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "AccessGateCode2",
          optional: false
        },
        {
          messageNumber: 3,
          variable: "AccessGateCode3",
          optional: true,
          enableSwitchVar: "AccessGateCode3Enabled"
        }
      ]
    },
    {
      label: "Key Access",
      filename: "Cortex.KeyAccess.tsx",
      description: "A description of relevant key access policies.",
      messages: [
        {
          messageNumber: 1,
          variable: "MoveKeyAccessLock1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "MoveKeyAccessLock2",
          optional: false
        }
      ]
    },
    {
      label: "Padlock / DaVinci Access",
      filename: "Cortex.PadlockAccess.tsx",
      description: "A description of padlock availability and policies for storage units.",
      messages: [
        {
          messageNumber: 1,
          variable: "FeaturePadlocks1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "FeaturePadlocks2",
          optional: false
        }
      ]
    },
    {
      label: "Tour",
      filename: "Cortex.Tour.tsx",
      description:
        "A description of tour availability and typically, if available, whether advanced scheduling is required and if so how to schedule (calling facility, emailing, etc.).",
      messages: [
        {
          messageNumber: 1,
          variable: "MoveTour1",
          optional: false
        }
      ]
    },
    {
      label: "Unit Number",
      filename: "Cortex.UnitNumber.tsx",
      description: "A description of how a current tenant can find their unit number (typically in their email receipt).",
      messages: [
        {
          messageNumber: 1,
          variable: "AccessUnitNumber1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "AccessUnitNumber2",
          optional: false
        },
        {
          messageNumber: 3,
          variable: "AccessUnitNumber3",
          optional: true,
          enableSwitchVar: "AccessUnitNumber3Enabled"
        }
      ]
    },
    {
      label: "Auctions",
      filename: "Cortex.Auction.tsx",
      description:
        "FeatureAuction1 is a general description of storage unit auction availability. FeatureWonAuction messages describe what to do if you've won an auction.",
      messages: [
        {
          messageNumber: 1,
          variable: "FeatureAuction1",
          optional: false
        },
        {
          messageNumber: 1,
          variable: "FeatureWonAuction1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "FeatureWonAuction2",
          optional: true,
          enableSwitchVar: "FeatureWonAuction2Enabled"
        }
      ]
    },
    {
      label: "Climate Control",
      filename: "Cortex.ClimateControl.tsx",
      description: "A description of climate controlled storage unit availability and features.",
      messages: [
        {
          messageNumber: 1,
          variable: "FeatureClimateControl1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "FeatureClimateControl2",
          optional: true,
          enableSwitchVar: "FeatureClimateControl2Enabled"
        }
      ]
    },
    {
      label: "Dollies",
      filename: "Cortex.Dollies.tsx",
      description: "A description of dolly availability for moving purposes, including rental policies and procedures.",
      messages: [
        {
          messageNumber: 1,
          variable: "MoveDolly1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "MoveDolly2",
          optional: true,
          enableSwitchVar: "MoveDolly2Enabled"
        }
      ]
    },
    {
      label: "Drive-Up Units",
      filename: "Cortex.DriveUp.tsx",
      description: "A description of drive-up storage unit availability and access features.",
      messages: [
        {
          messageNumber: 1,
          variable: "FeatureDriveUp1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "FeatureDriveUp2",
          optional: true,
          enableSwitchVar: "FeatureDriveUp2Enabled"
        }
      ]
    },
    {
      label: "Franchise",
      filename: "Cortex.Franchise.tsx",
      description: "A description of franchise opportunities and information for potential business partners.",
      messages: [
        {
          messageNumber: 1,
          variable: "PurchaseFranchise1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "PurchaseFranchise2",
          optional: true,
          enableSwitchVar: "PurchaseFranchise2Enabled"
        }
      ]
    },
    {
      label: "Lights",
      filename: "Cortex.Lights.tsx",
      description: "A description of lighting availability and policies in storage units and facility areas.",
      messages: [
        {
          messageNumber: 1,
          variable: "FeatureLights1",
          optional: false
        }
      ]
    },
    {
      label: "Maintenance/Pests",
      filename: "Cortex.MaintenancePest.tsx",
      description: "A description of facility maintenance procedures and pest control policies.",
      messages: [
        {
          messageNumber: 1,
          variable: "FeatureMaintenancePest1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "FeatureMaintenancePest2",
          optional: true,
          enableSwitchVar: "FeatureMaintenancePest2Enabled"
        }
      ]
    },
    {
      label: "Mobile App",
      filename: "Cortex.MobileApp.tsx",
      description: "A description of mobile application availability and features for managing storage accounts.",
      messages: [
        {
          messageNumber: 1,
          variable: "MobileApp1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "MobileApp2",
          optional: true,
          enableSwitchVar: "HasMobileApp2Enabled"
        }
      ]
    },
    {
      label: "Moving Services",
      filename: "Cortex.MovingServices.tsx",
      description: "A description of moving services offered by the facility or partner companies.",
      messages: [
        {
          messageNumber: 1,
          variable: "FeatureMovingServices1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "FeatureMovingServices2",
          optional: true,
          enableSwitchVar: "FeatureMovingServices2Enabled"
        }
      ]
    },
    {
      label: "Moving Truck",
      filename: "Cortex.MovingTruck.tsx",
      description: "A description of moving truck rental availability and policies.",
      messages: [
        {
          messageNumber: 1,
          variable: "MoveMovingTruck1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "MoveMovingTruck2",
          optional: true,
          enableSwitchVar: "MoveMovingTruck2Enabled"
        }
      ]
    },
    {
      label: "Packing Supplies",
      filename: "Cortex.PackingSupplies.tsx",
      description: "A description of packing supplies and materials available for purchase or rent.",
      messages: [
        {
          messageNumber: 1,
          variable: "MoveMovingSupplies1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "MoveMovingSupplies2",
          optional: true,
          enableSwitchVar: "MoveMovingSupplies2Enabled"
        }
      ]
    },
    {
      label: "Security",
      filename: "Cortex.Security.tsx",
      description: "A description of facility security measures and monitoring systems.",
      messages: [
        {
          messageNumber: 1,
          variable: "FeatureSecurity1",
          optional: false
        }
      ]
    },
    {
      label: "Wine",
      filename: "Cortex.WineStorage.tsx",
      description: "A description of specialized wine storage options and climate control features.",
      messages: [
        {
          messageNumber: 1,
          variable: "FeatureWineStorage1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "FeatureWineStorage2",
          optional: true,
          enableSwitchVar: "FeatureWineStorage2Enabled"
        }
      ]
    },
    {
      label: "Cancellation",
      filename: "Cortex.Cancellation.tsx",
      description: "A description of lease cancellation policies and procedures.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseCancellation1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseCancellation2",
          optional: false
        },
        {
          messageNumber: 3,
          variable: "LeaseCancellation3",
          optional: true,
          enableSwitchVar: "LeaseCancellation3Enabled"
        }
      ]
    },
    {
      label: "Contract Lengths",
      filename: "Cortex.ContractLengths.tsx",
      description: "A description of available lease contract lengths and terms.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseContractLengths1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseContractLengths2",
          optional: false
        },
        {
          messageNumber: 3,
          variable: "LeaseContractLengths3",
          optional: true,
          enableSwitchVar: "LeaseContractLengths3Enabled"
        },
        {
          messageNumber: 4,
          variable: "LeaseContractLengths4",
          optional: true,
          enableSwitchVar: "LeaseContractLengths4Enabled"
        }
      ]
    },
    {
      label: "Covid",
      filename: "Cortex.Covid.tsx",
      description: "A description of COVID-19 related policies and safety procedures.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseCovid",
          optional: false
        }
      ]
    },
    {
      label: "Cut Locks",
      filename: "Cortex.CutLocks.tsx",
      description: "A description of cut lock policies and procedures for overdue accounts.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseCutLocks",
          optional: false
        }
      ]
    },
    {
      label: "Facility Access",
      filename: "Cortex.FacilityAccess.tsx",
      description: "A description of general facility access hours and policies.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseFacilityAccess1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseFacilityAccess2",
          optional: false
        }
      ]
    },
    {
      label: "File A Claim",
      filename: "Cortex.Claim.tsx",
      description: "A description of how to file insurance claims and claim procedures.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseClaim1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseClaim2",
          optional: true,
          enableSwitchVar: "LeaseClaim2Enabled"
        }
      ]
    },
    {
      label: "Get Lease",
      filename: "Cortex.GetLease.tsx",
      description: "A description of how to obtain and access lease documents.",
      messages: [
        {
          messageNumber: 1,
          variable: "AccountGetLease1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "AccountGetLease2",
          optional: true,
          enableSwitchVar: "AccountGetLease2Enabled"
        }
      ]
    },
    {
      label: "Identification",
      filename: "Cortex.Identification.tsx",
      description: "A description of identification requirements for renting storage units.",
      messages: [
        {
          messageNumber: 1,
          variable: "PurchaseIdentification1",
          optional: false
        }
      ]
    },
    {
      label: "Insurance",
      filename: "Cortex.Insurance.tsx",
      description: "A description of insurance requirements and options for stored items.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseInsurance1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseInsurance2",
          optional: false
        },
        {
          messageNumber: 3,
          variable: "LeaseInsurance3",
          optional: false
        }
      ]
    },
    {
      label: "Live In Unit",
      filename: "Cortex.LiveInUnit.tsx",
      description: "A description of policies regarding living in storage units (typically prohibited).",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseLiveInUnit1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseLiveInUnit2",
          optional: true,
          enableSwitchVar: "LeaseLiveInUnit2Enabled"
        }
      ]
    },
    {
      label: "Monthly Pricing",
      filename: "Cortex.MonthlyPayments.tsx",
      description: "A description of monthly pricing structure and payment schedules.",
      messages: [
        {
          messageNumber: 1,
          variable: "PurchaseMonthlyPayments1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "PurchaseMonthlyPayments2",
          optional: true,
          enableSwitchVar: "PurchaseMonthlyPayments2Enabled"
        }
      ]
    },
    {
      label: "Move Out Policy",
      filename: "Cortex.MoveOutPolicy.tsx",
      description: "A description of procedures and requirements for moving out of storage units.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseMoveOutPolicy1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseMoveOutPolicy2",
          optional: false
        },
        {
          messageNumber: 3,
          variable: "LeaseMoveOutPolicy3",
          optional: true,
          enableSwitchVar: "LeaseMoveOutPolicy3Enabled"
        }
      ]
    },
    {
      label: "Overlock",
      filename: "Cortex.Overlock.tsx",
      description: "A description of overlock policies for overdue accounts and access restrictions.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseOverlock1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseOverlock2",
          optional: false
        },
        {
          messageNumber: 3,
          variable: "LeaseOverlock3",
          optional: true,
          enableSwitchVar: "LeaseOverlock3Enabled"
        }
      ]
    },
    {
      label: "Pay Online",
      filename: "Cortex.PayOnline.tsx",
      description: "A description of online payment options and procedures.",
      messages: [
        {
          messageNumber: 1,
          variable: "PurchasePayOnline1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "PurchasePayOnline2",
          optional: true,
          enableSwitchVar: "PurchasePayOnline2Enabled"
        }
      ]
    },
    {
      label: "Payment Options",
      filename: "Cortex.PaymentOptions.tsx",
      description: "A description of available payment methods and options.",
      messages: [
        {
          messageNumber: 1,
          variable: "PurchasePaymentOptions1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "PurchasePaymentOptions2",
          optional: true,
          enableSwitchVar: "PurchasePaymentOptions2Enabled"
        }
      ]
    },
    {
      label: "Pricing",
      filename: "Cortex.Pricing.tsx",
      description: "A description of general pricing information and rate structures.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeasePricing1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeasePricing2",
          optional: true,
          enableSwitchVar: "LeasePricing2Enabled"
        },
        {
          messageNumber: 3,
          variable: "LeasePricing3",
          optional: true,
          enableSwitchVar: "LeasePricing3Enabled"
        }
      ]
    },
    {
      label: "Prorate",
      filename: "Cortex.Prorate.tsx",
      description: "A description of prorated billing policies and calculations.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseProrate1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseProrate2",
          optional: true,
          enableSwitchVar: "LeaseProrate2Enabled"
        }
      ]
    },
    {
      label: "Refunds",
      filename: "Cortex.Refunds.tsx",
      description: "A description of refund policies and procedures.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseRefunds1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseRefunds2",
          optional: true,
          enableSwitchVar: "LeaseRefunds2Enabled"
        }
      ]
    },
    {
      label: "Storable Items",
      filename: "Cortex.StorableItems.tsx",
      description: "A description of what items can and cannot be stored in storage units.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseStorableItems1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseStorableItems2",
          optional: true,
          enableSwitchVar: "LeaseStorableItems2Enabled"
        },
        {
          messageNumber: 3,
          variable: "LeaseStorableItems3",
          optional: true,
          enableSwitchVar: "LeaseStorableItems3Enabled"
        }
      ]
    },
    {
      label: "Unit Transfer",
      filename: "Cortex.UnitTransfer.tsx",
      description: "A description of policies and procedures for transferring between storage units.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseUnitTransfer1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseUnitTransfer2",
          optional: true,
          enableSwitchVar: "LeaseUnitTransfer2Enabled"
        }
      ]
    },
    {
      label: "Work In Unit",
      filename: "Cortex.WorkInUnit.tsx",
      description: "A description of policies regarding working or conducting business in storage units.",
      messages: [
        {
          messageNumber: 1,
          variable: "LeaseWorkIn1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "LeaseWorkIn2",
          optional: true,
          enableSwitchVar: "LeaseWorkIn2Enabled"
        }
      ]
    },
    {
      label: "Admin Fee",
      filename: "Cortex.AdminFee.tsx",
      description: "A description of administrative fees and charges associated with storage rentals.",
      messages: [
        {
          messageNumber: 1,
          variable: "CostAdminFee1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "CostAdminFee2",
          optional: true,
          enableSwitchVar: "CostAdminFee2Enabled"
        }
      ]
    },
    {
      label: "Credit Card Fee",
      filename: "Cortex.CreditCardFee.tsx",
      description: "A description of credit card processing fees and payment charges.",
      messages: [
        {
          messageNumber: 1,
          variable: "CostCreditCardFee1",
          optional: false
        },
        {
          messageNumber: 2,
          variable: "CostCreditCardFee2",
          optional: true,
          enableSwitchVar: "CostCreditCardFee2Enabled"
        }
      ]
    },
    {
      label: "Ceiling Height",
      filename: "Cortex.StandardCeilingHeight.tsx",
      description:
        "The standard ceiling height of this facility's storage units. This message is unique - it should be the height in # and unit. e.g., '8ft'. Include no other text or punctuation.",
      messages: [
        {
          messageNumber: 1,
          variable: "StandardCeilingHeight",
          optional: false
        }
      ]
    }
  ]
};

export default worksheetMessages;
